import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';
const container = document.getElementById('root');
if (!container)
    throw new Error('Root element not found');
const root = createRoot(container);
root.render(_jsx(App, {}));
